import React, { Component, Fragment } from "react";
import _, { size } from "lodash";
import { Col, Row } from "reactstrap";
import "./style.css";
import { themeService } from "../../../../theme/service/activeTheme.service";
import { iconToShow, iconTwoShow } from "../../variables";
import LeftImage from "images/left-detail-turnout.jpg";
import RightImage from "images/right-detail-turnout.jpg";
import { SignatureImage } from "../../utils/SignatureImage";
import { languageService } from "../../../../Language/language.service";

class DetailedTurnoutInspectionForm extends React.Component {
  constructor(props) {
    super(props);
    this.localState = {
      data: {},
      basicData: {},
      lh: true,
      signatureImage: null,
    };
    this.config = {
      minRows: 11,
    };
    this.calculateReportData();
  }
  calculateReportData() {
    let { data } = this.localState;
    let { basicData } = this.localState;
    let { props } = this;
    if (props.assetData) {
      props.assetData.form &&
        props.assetData.form.forEach((field) => {
          if (field && field.id) data[field.id] = field.value;
        });
    }
    if (props.basicData) {
      basicData = props.basicData;
    }
    this.localState = {
      ...this.localState,
      data: { ...data },
      basicData: { ...basicData },
      lh: data.post === "Right" ? false : true,
    };
    this.findAndSetSignature(this.props.usersSignatures);
  }
  findAndSetSignature(usersSignatures) {
    let sigImage = usersSignatures && usersSignatures.find((sItem) => sItem.email === this.props.testExec.user.email);
    this.localState = {
      ...this.localState,
      signatureImage: sigImage ? sigImage.signature.imgName : null,
    };
  }

  renderHiglightedCondition(data) {
    const textStyle = {
      marginLeft: "5px",
      color: data !== "Good" ? "red" : "inherit",
    };

    return <span style={textStyle}> {data}</span>;
  }

  render() {
    const inlineStyles = {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      height: "100%",
      width: "100%",
      whiteSpace: "nowrap",
      textAlign: "center",
      transform: "rotate(-90deg)",
      color: "red",
    };
    let { props } = this;
    let { data, basicData, lh } = this.localState;
    const logo1Source = themeService(iconToShow);
    let lang = localStorage.getItem("language");
    let displaySpacer = lang !== "fr" ? <span className="spacer"></span> : null;
    return (
      <React.Fragment>
        <div className="mainContent table-report turnout-insp-form detailed last-page-break-print" style={{ minHeight: "800px" }}>
          <Row>
            <Col md={3}>{logo1Source && <img src={logo1Source} style={{ width: "100%" }} alt="Logo" />}</Col>
            <Col md={9}>
              <h3 style={{ marginTop: "18px" }}>{`${languageService("DETAILED MAINLINE TURNOUT INSPECTION FORM")}`} </h3>
            </Col>
            <span className="spacer"></span>
            {displaySpacer}
            <Col md={6}>
              <h5>
                <div className="title-rpt">
                  <label style={{ fontWeight: "bold", fontSize: "23px" }}>{languageService("Turnout Name and MLG")}: </label>
                  <span> {props.assetData && props.assetData.assetName}</span>
                </div>
              </h5>
            </Col>

            <Col md={6}>
              <h5>
                <div className="title-rpt">
                  <label style={{ fontWeight: "bold", fontSize: "23px" }}>
                    {languageService("Samson")}/{languageService("Standard")}:{" "}
                  </label>
                  <span style={{ marginLeft: "5px" }}> {data && data.samstnd}</span>
                </div>
              </h5>
            </Col>
            <Col md={6}>
              <h5>
                <div className="title-rpt">
                  <label style={{ fontWeight: "bold", fontSize: "23px" }}>
                    {languageService("Left")}/{languageService("Right")}:{" "}
                  </label>
                  <span style={{ marginLeft: "5px" }}> {data && data.post}</span>
                </div>
              </h5>
            </Col>

            <Col md={6}>
              <h5>
                <div className="title-rpt">
                  <label style={{ fontWeight: "bold", fontSize: "23px" }}>{languageService("Inspection Date")}: </label>
                  <span> {basicData.date}</span>
                </div>
              </h5>
            </Col>

            <Col md={6}>
              <h5>
                <div className="title-rpt">
                  <label style={{ fontWeight: "bold", fontSize: "23px" }}>{languageService("Type of Turnout")}: </label>
                  <span style={{ marginLeft: "5px" }}> {data && data.toti}</span>
                </div>
              </h5>
            </Col>

            <Col md={6}>
              <h5>
                <div className="title-rpt">
                  <label style={{ fontWeight: "bold", fontSize: "23px" }}>{languageService("Inspected By")}: </label>
                  <span> {basicData.userName}</span>
                </div>
              </h5>
            </Col>

            <Col md={6}>
              <h5>
                <div className="title-rpt">
                  <label style={{ fontWeight: "bold", fontSize: "23px" }}>{languageService("Rail Size")}: </label>
                  <span style={{ marginLeft: "5px" }}> {data && data.rsize}</span>
                </div>
              </h5>
            </Col>

            <Col md={6}>
              <h5>
                <div className="title-rpt">
                  <label style={{ fontWeight: "bold", fontSize: "23px" }}>{languageService("Signature")}: </label>
                  <span>
                    <SignatureImage placement={"tableCell"} signatureImage={this.props.signatureImage} />
                  </span>
                </div>
              </h5>
            </Col>
          </Row>
          {displaySpacer}
          <Row>
            <Col md={4}>
              <table className="table" style={{ width: "100%" }}>
                <tbody>
                  <tr>
                    <td className="tr-bordered" style={{ textAlign: "center", verticalAlign: "middle" }} colSpan={6} rowSpan={1}>
                      <h4 style={{ fontWeight: "bold" }}> {languageService("General Conditions")}</h4>
                    </td>
                  </tr>
                  <tr>
                    <td className="tr-bordered" style={{ height: "55px" }} colSpan={2} rowSpan={1}>
                      <label style={{ marginLeft: "5px", fontWeight: "bold" }}>{languageService("Ballast & Drainage")} </label>
                    </td>
                    <td className="tr-bordered" style={{ height: "55px" }} colSpan={4} rowSpan={1}>
                      {this.renderHiglightedCondition(data && data.ballast)}
                    </td>
                  </tr>

                  <tr>
                    <td className="tr-bordered" style={{ height: "39px" }} colSpan={2} rowSpan={1}>
                      <label style={{ marginLeft: "5px", fontWeight: "bold" }}>{languageService("Comments")} </label>
                    </td>

                    <td className="tr-bordered" style={{ height: "39px" }} colSpan={4} rowSpan={1}>
                      <span style={{ marginLeft: "5px" }}> {data && data.com1} </span>
                    </td>
                  </tr>

                  <tr>
                    <td className="tr-bordered" style={{ height: "55px" }} colSpan={2} rowSpan={1}>
                      <label style={{ marginLeft: "5px", fontWeight: "bold" }}>{languageService("Alignment")} </label>
                    </td>
                    <td className="tr-bordered" style={{ height: "55px" }} colSpan={2} rowSpan={1}>
                      <label style={{ marginLeft: "5px", fontWeight: "bold" }}>{languageService("Mainline")}: </label>
                      {this.renderHiglightedCondition(data && data.main1)}
                    </td>
                    <td className="tr-bordered" style={{ height: "55px" }} colSpan={2} rowSpan={1}>
                      <label style={{ marginLeft: "5px", fontWeight: "bold" }}>{languageService("Turnout")}: </label>

                      {this.renderHiglightedCondition(data && data.side1)}
                    </td>
                  </tr>

                  <tr>
                    <td className="tr-bordered" style={{ height: "39px" }} colSpan={2} rowSpan={1}>
                      <label style={{ marginLeft: "5px", fontWeight: "bold" }}>{languageService("Comments")} </label>
                    </td>

                    <td className="tr-bordered" style={{ height: "39px" }} colSpan={2} rowSpan={1}>
                      <span style={{ marginLeft: "5px" }}> {data && data.com2}</span>
                    </td>

                    <td className="tr-bordered" style={{ height: "39px" }} colSpan={2} rowSpan={1}>
                      <span style={{ marginLeft: "5px" }}> {data && data.com3}</span>
                    </td>
                  </tr>

                  <tr>
                    <td className="tr-bordered" style={{ height: "55px" }} colSpan={2} rowSpan={1}>
                      <label style={{ marginLeft: "5px", fontWeight: "bold" }}>{languageService("Surface")} </label>
                    </td>
                    <td className="tr-bordered" style={{ height: "55px" }} colSpan={2} rowSpan={1}>
                      <label style={{ marginLeft: "5px", fontWeight: "bold" }}>{languageService("Mainline")}: </label>

                      {this.renderHiglightedCondition(data && data.main2)}
                    </td>
                    <td className="tr-bordered" style={{ height: "55px" }} colSpan={2} rowSpan={1}>
                      <label style={{ marginLeft: "5px", fontWeight: "bold" }}>{languageService("Turnout")}: </label>

                      {this.renderHiglightedCondition(data && data.side2)}
                    </td>
                  </tr>

                  <tr>
                    <td className="tr-bordered" style={{ height: "39px" }} colSpan={2} rowSpan={1}>
                      <label style={{ marginLeft: "5px", fontWeight: "bold" }}>{languageService("Comments")} </label>
                    </td>

                    <td className="tr-bordered" style={{ height: "39px" }} colSpan={2} rowSpan={1}>
                      <span style={{ marginLeft: "5px" }}> {data && data.com4}</span>
                    </td>

                    <td className="tr-bordered" style={{ height: "39px" }} colSpan={2} rowSpan={1}>
                      <span style={{ marginLeft: "5px" }}> {data && data.com5}</span>
                    </td>
                  </tr>

                  <tr>
                    <td className="tr-bordered" style={{ height: "55px" }} colSpan={2} rowSpan={1}>
                      <label style={{ marginLeft: "5px", fontWeight: "bold" }}>{languageService("Ties")} </label>
                    </td>
                    <td className="tr-bordered" style={{ height: "55px" }} colSpan={4} rowSpan={1}>
                      {this.renderHiglightedCondition(data && data.ties)}
                    </td>
                  </tr>

                  <tr>
                    <td className="tr-bordered" style={{ height: "39px" }} colSpan={2} rowSpan={1}>
                      <label style={{ marginLeft: "5px", fontWeight: "bold" }}>{languageService("Comments")} </label>
                    </td>

                    <td className="tr-bordered" style={{ height: "39px" }} colSpan={4} rowSpan={1}>
                      <span style={{ marginLeft: "5px" }}> {data && data.com6}</span>
                    </td>
                  </tr>

                  <tr>
                    <td className="tr-bordered" style={{ height: "55px" }} colSpan={2} rowSpan={1}>
                      <label style={{ marginLeft: "5px", fontWeight: "bold" }}>{languageService("Plates")} </label>
                    </td>
                    <td className="tr-bordered" style={{ height: "55px" }} colSpan={4} rowSpan={1}>
                      {this.renderHiglightedCondition(data && data.plate)}
                    </td>
                  </tr>

                  <tr>
                    <td className="tr-bordered" style={{ height: "39px" }} colSpan={2} rowSpan={1}>
                      <label style={{ marginLeft: "5px", fontWeight: "bold" }}>{languageService("Comments")} </label>
                    </td>

                    <td className="tr-bordered" style={{ height: "39px" }} colSpan={4} rowSpan={1}>
                      <span style={{ marginLeft: "5px" }}> {data && data.com7}</span>
                    </td>
                  </tr>

                  <tr>
                    <td className="tr-bordered" style={{ height: "55px" }} colSpan={2} rowSpan={1}>
                      <label style={{ marginLeft: "5px", fontWeight: "bold" }}>{languageService("Rails")} </label>
                    </td>
                    <td className="tr-bordered" style={{ height: "55px" }} colSpan={4} rowSpan={1}>
                      {this.renderHiglightedCondition(data && data.rail)}
                    </td>
                  </tr>

                  <tr>
                    <td className="tr-bordered" style={{ height: "39px" }} colSpan={2} rowSpan={1}>
                      <label style={{ marginLeft: "5px", fontWeight: "bold" }}>{languageService("Comments")} </label>
                    </td>

                    <td className="tr-bordered" style={{ height: "39px" }} colSpan={4} rowSpan={1}>
                      <span style={{ marginLeft: "5px" }}> {data && data.com8}</span>
                    </td>
                  </tr>

                  <tr>
                    <td className="tr-bordered" style={{ height: "55px" }} colSpan={2} rowSpan={1}>
                      <label style={{ marginLeft: "5px", fontWeight: "bold" }}>{languageService("Cotter Pins")} </label>
                    </td>
                    <td className="tr-bordered" style={{ height: "55px" }} colSpan={4} rowSpan={1}>
                      {this.renderHiglightedCondition(data && data.pins)}
                    </td>
                  </tr>

                  <tr>
                    <td className="tr-bordered" style={{ height: "39px" }} colSpan={2} rowSpan={1}>
                      <label style={{ marginLeft: "5px", fontWeight: "bold" }}>{languageService("Comments")} </label>
                    </td>

                    <td className="tr-bordered" style={{ height: "39px" }} colSpan={4} rowSpan={1}>
                      <span style={{ marginLeft: "5px" }}> {data && data.com9}</span>
                    </td>
                  </tr>
                  <tr>
                    <td className="tr-bordered" style={{ height: "55px" }} colSpan={2} rowSpan={1}>
                      <label style={{ marginLeft: "5px", fontWeight: "bold" }}>{languageService("Bolts")} </label>
                    </td>
                    <td className="tr-bordered" style={{ height: "55px" }} colSpan={4} rowSpan={1}>
                      {this.renderHiglightedCondition(data && data.bolt)}
                    </td>
                  </tr>

                  <tr>
                    <td className="tr-bordered" style={{ height: "39px" }} colSpan={2} rowSpan={1}>
                      <label style={{ marginLeft: "5px", fontWeight: "bold" }}>{languageService("Comments")} </label>
                    </td>

                    <td className="tr-bordered" style={{ height: "39px" }} colSpan={4} rowSpan={1}>
                      <span style={{ marginLeft: "5px" }}> {data && data.com10}</span>
                    </td>
                  </tr>

                  <tr>
                    <td className="tr-bordered" style={{ height: "55px" }} colSpan={2} rowSpan={1}>
                      <label style={{ marginLeft: "5px", fontWeight: "bold" }}>{languageService("Rail Braces")} </label>
                    </td>
                    <td className="tr-bordered" style={{ height: "55px" }} colSpan={2} rowSpan={1}>
                      <label style={{ marginLeft: "5px", fontWeight: "bold" }}>{languageService("Type")}: </label>

                      {this.renderHiglightedCondition(data && data.type1)}
                    </td>
                    <td className="tr-bordered" style={{ height: "55px" }} colSpan={2} rowSpan={1}>
                      <label style={{ marginLeft: "5px", fontWeight: "bold" }}>{languageService("Condition")}: </label>

                      {this.renderHiglightedCondition(data && data.cond1)}
                    </td>
                  </tr>

                  <tr>
                    <td className="tr-bordered" style={{ height: "39px" }} colSpan={2} rowSpan={1}>
                      <label style={{ marginLeft: "5px", fontWeight: "bold" }}>{languageService("Comments")} </label>
                    </td>

                    <td className="tr-bordered" style={{ height: "39px" }} colSpan={2} rowSpan={1}>
                      <span style={{ marginLeft: "5px" }}> {data && data.com11}</span>
                    </td>

                    <td className="tr-bordered" style={{ height: "39px" }} colSpan={2} rowSpan={1}>
                      <span style={{ marginLeft: "5px" }}> {data && data.com12}</span>
                    </td>
                  </tr>

                  <tr>
                    <td className="tr-bordered" style={{ height: "55px" }} colSpan={2} rowSpan={1}>
                      <label style={{ marginLeft: "5px", fontWeight: "bold" }}>{languageService("Rail Anchors")} </label>
                    </td>
                    <td className="tr-bordered" style={{ height: "55px" }} colSpan={4} rowSpan={1}>
                      {this.renderHiglightedCondition(data && data.ranchor)}
                    </td>
                  </tr>

                  <tr>
                    <td className="tr-bordered" style={{ height: "39px" }} colSpan={2} rowSpan={1}>
                      <label style={{ marginLeft: "5px", fontWeight: "bold" }}>{languageService("Comments")} </label>
                    </td>

                    <td className="tr-bordered" style={{ height: "39px" }} colSpan={4} rowSpan={1}>
                      <span style={{ marginLeft: "5px" }}> {data && data.com13}</span>
                    </td>
                  </tr>

                  <tr>
                    <td className="tr-bordered" style={{ height: "55px" }} colSpan={2} rowSpan={1}>
                      <label style={{ marginLeft: "5px", fontWeight: "bold" }}>{languageService("Points Fit")} </label>
                    </td>
                    <td className="tr-bordered" style={{ height: "55px" }} colSpan={2} rowSpan={1}>
                      <label style={{ marginLeft: "5px", fontWeight: "bold" }}>{languageService("Left")}: </label>

                      {this.renderHiglightedCondition(data && data.left1)}
                    </td>
                    <td className="tr-bordered" style={{ height: "55px" }} colSpan={2} rowSpan={1}>
                      <label style={{ marginLeft: "5px", fontWeight: "bold" }}>{languageService("Right")}: </label>

                      {this.renderHiglightedCondition(data && data.right1)}
                    </td>
                  </tr>

                  <tr>
                    <td className="tr-bordered" style={{ height: "39px" }} colSpan={2} rowSpan={1}>
                      <label style={{ marginLeft: "5px", fontWeight: "bold" }}>{languageService("Comments")} </label>
                    </td>

                    <td className="tr-bordered" style={{ height: "39px" }} colSpan={2} rowSpan={1}>
                      <span style={{ marginLeft: "5px" }}> {data && data.com14}</span>
                    </td>

                    <td className="tr-bordered" style={{ height: "39px" }} colSpan={2} rowSpan={1}>
                      <span style={{ marginLeft: "5px" }}> {data && data.com15}</span>
                    </td>
                  </tr>

                  <tr>
                    <td className="tr-bordered" style={{ height: "55px" }} colSpan={2} rowSpan={1}>
                      <label style={{ marginLeft: "5px", fontWeight: "bold" }}>{languageService("Points Running Surface")} </label>
                    </td>
                    <td className="tr-bordered" style={{ height: "55px" }} colSpan={2} rowSpan={1}>
                      <label style={{ marginLeft: "5px", fontWeight: "bold" }}>{languageService("Left")}: </label>

                      {this.renderHiglightedCondition(data && data.left2)}
                    </td>
                    <td className="tr-bordered" style={{ height: "55px" }} colSpan={2} rowSpan={1}>
                      <label style={{ marginLeft: "5px", fontWeight: "bold" }}>{languageService("Right")}: </label>

                      {this.renderHiglightedCondition(data && data.right2)}
                    </td>
                  </tr>

                  <tr>
                    <td className="tr-bordered" style={{ height: "39px" }} colSpan={2} rowSpan={1}>
                      <label style={{ marginLeft: "5px", fontWeight: "bold" }}>{languageService("Comments")} </label>
                    </td>

                    <td className="tr-bordered" style={{ height: "39px" }} colSpan={2} rowSpan={1}>
                      <span style={{ marginLeft: "5px" }}> {data && data.com16}</span>
                    </td>

                    <td className="tr-bordered" style={{ height: "39px" }} colSpan={2} rowSpan={1}>
                      <span style={{ marginLeft: "5px" }}> {data && data.com17}</span>
                    </td>
                  </tr>

                  <tr>
                    <td className="tr-bordered" style={{ height: "55px" }} colSpan={2} rowSpan={1}>
                      <label style={{ marginLeft: "5px", fontWeight: "bold" }}>{languageService("Heel Block")} </label>
                    </td>
                    <td className="tr-bordered" style={{ height: "55px" }} colSpan={2} rowSpan={1}>
                      <label style={{ marginLeft: "5px", fontWeight: "bold" }}>{languageService("Left")}: </label>

                      {this.renderHiglightedCondition(data && data.left3)}
                    </td>
                    <td className="tr-bordered" style={{ height: "55px" }} colSpan={2} rowSpan={1}>
                      <label style={{ marginLeft: "5px", fontWeight: "bold" }}>{languageService("Right")}: </label>

                      {this.renderHiglightedCondition(data && data.right3)}
                    </td>
                  </tr>

                  <tr>
                    <td className="tr-bordered" style={{ height: "39px" }} colSpan={2} rowSpan={1}>
                      <label style={{ marginLeft: "5px", fontWeight: "bold" }}>{languageService("Comments")} </label>
                    </td>

                    <td className="tr-bordered" style={{ height: "39px" }} colSpan={2} rowSpan={1}>
                      <span style={{ marginLeft: "5px" }}> {data && data.com18}</span>
                    </td>

                    <td className="tr-bordered" style={{ height: "39px" }} colSpan={2} rowSpan={1}>
                      <span style={{ marginLeft: "5px" }}> {data && data.com19}</span>
                    </td>
                  </tr>

                  <tr>
                    <td className="tr-bordered" style={{ height: "55px" }} colSpan={2} rowSpan={1}>
                      <label style={{ marginLeft: "5px", fontWeight: "bold" }}>{languageService("Switch Lock/Keeper")} </label>
                    </td>
                    <td className="tr-bordered" style={{ height: "55px" }} colSpan={4} rowSpan={1}>
                      {this.renderHiglightedCondition(data && data.switchkep)}
                    </td>
                  </tr>

                  <tr>
                    <td className="tr-bordered" style={{ height: "39px" }} colSpan={2} rowSpan={1}>
                      <label style={{ marginLeft: "5px", fontWeight: "bold" }}>{languageService("Comments")} </label>
                    </td>

                    <td className="tr-bordered" style={{ height: "39px" }} colSpan={4} rowSpan={1}>
                      <span style={{ marginLeft: "5px" }}> {data && data.com20}</span>
                    </td>
                  </tr>

                  <tr>
                    <td className="tr-bordered" style={{ height: "55px" }} colSpan={2} rowSpan={1}>
                      <label style={{ marginLeft: "5px", fontWeight: "bold" }}>{languageService("Switch Stand")} </label>
                    </td>
                    <td className="tr-bordered" style={{ height: "55px" }} colSpan={4} rowSpan={1}>
                      {this.renderHiglightedCondition(data && data.cond2)}
                    </td>
                  </tr>

                  <tr>
                    <td className="tr-bordered" style={{ height: "39px" }} colSpan={2} rowSpan={1}>
                      <label style={{ marginLeft: "5px", fontWeight: "bold" }}>{languageService("Comments")} </label>
                    </td>

                    <td className="tr-bordered" style={{ height: "39px" }} colSpan={4} rowSpan={1}>
                      <span style={{ marginLeft: "5px" }}> {data && data.com21}</span>
                    </td>
                  </tr>

                  {/* <tr>
                    <td className="tr-bordered" colSpan={2} rowSpan={1}>
                      {languageService("Switch Target")}
                    </td>
                   <td className="tr-bordered" style={{ height: "55px" }}  colSpan={4} rowSpan={1}>
                      {languageService("Type")}:<span style={{marginLeft:"5px"}} > {data && data.starget}</span>
                    </td>
                  </tr> */}

                  <tr>
                    <td className="tr-bordered" style={{ height: "55px" }} colSpan={2} rowSpan={1}>
                      <label style={{ marginLeft: "5px", fontWeight: "bold" }}>{languageService("Frog General")} </label>
                    </td>
                    <td className="tr-bordered" style={{ height: "55px" }} colSpan={4} rowSpan={1}>
                      {this.renderHiglightedCondition(data && data.genfrog)}
                    </td>
                  </tr>

                  <tr>
                    <td className="tr-bordered" style={{ height: "39px" }} colSpan={2} rowSpan={1}>
                      <label style={{ marginLeft: "5px", fontWeight: "bold" }}>{languageService("Comments")} </label>
                    </td>

                    <td className="tr-bordered" style={{ height: "39px" }} colSpan={4} rowSpan={1}>
                      <span style={{ marginLeft: "5px" }}> {data && data.com22}</span>
                    </td>
                  </tr>

                  <tr>
                    <td className="tr-bordered" style={{ height: "55px" }} colSpan={2} rowSpan={1}>
                      <label style={{ marginLeft: "5px", fontWeight: "bold" }}>{languageService("Lubrication")} </label>
                    </td>
                    <td className="tr-bordered" style={{ height: "55px" }} colSpan={4} rowSpan={1}>
                      {this.renderHiglightedCondition(data && data.lubric)}
                    </td>
                  </tr>

                  <tr>
                    <td className="tr-bordered" style={{ height: "39px" }} colSpan={2} rowSpan={1}>
                      <label style={{ marginLeft: "5px", fontWeight: "bold" }}>{languageService("Comments")} </label>
                    </td>

                    <td className="tr-bordered" style={{ height: "39px" }} colSpan={4} rowSpan={1}>
                      <span style={{ marginLeft: "5px" }}> {data && data.com23}</span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </Col>

            <Col md={8}>
              <table className="table" style={{ width: "100%" }}>
                <tbody>
                  <tr>
                    <td className="tr-bordered" style={{ textAlign: "center" }} colSpan={18} rowSpan={1}>
                      <label style={{ fontStyle: "italic" }}>
                        {" "}
                        {languageService(`Gauge and Crosslevel Measurements taken every 15' 6"`)}
                      </label>
                      <br></br>
                      <label style={{ fontStyle: "italic" }}> {languageService(`Values recorded in inches to the nearest 1/8"`)}</label>
                      <br></br>
                      <label style={{ fontStyle: "italic" }}>
                        {" "}
                        {languageService(`*If it is a smaller turnout, some values may not be needed`)}
                      </label>
                    </td>
                  </tr>

                  <tr>
                    <td className="tr-bordered" style={{ textAlign: "center", verticalAlign: "middle" }} colSpan={9} rowSpan={1}>
                      <h4 style={{ fontWeight: "bold" }}> {languageService("Mainline")}</h4>
                    </td>

                    <td className="tr-bordered" style={{ textAlign: "center", verticalAlign: "middle" }} colSpan={9} rowSpan={1}>
                      <h4 style={{ fontWeight: "bold" }}> {languageService("Turnout")}</h4>
                    </td>
                  </tr>

                  <tr>
                    <td className="tr-bordered" colSpan={4} rowSpan={1}>
                      <label style={{ marginLeft: "5px", fontWeight: "bold" }}>{languageService("10' Ahead of the Points")}</label>
                    </td>

                    <td className="tr-bordered" style={{ display: "-ms-inline-flexbox", flexDirection: "column" }} colSpan={5} rowSpan={1}>
                      <div style={{ marginLeft: "5px" }}>
                        <label style={{ fontWeight: "bold" }}>
                          {languageService("Gauge")}
                          {":"}
                        </label>

                        <span style={{ marginLeft: "5px" }}>
                          {data && data.fft1} {data && getFractionInches(data.fs1)}
                        </span>

                        <span></span>
                      </div>

                      <div style={{ marginLeft: "5px" }}>
                        <label style={{ fontWeight: "bold" }}>
                          {languageService("Crosslevel")} (+/-){":"}
                        </label>
                        <span style={{ marginLeft: "5px" }}>
                          {data && data.fft2} {data && getFractionInches(data.fs2)}
                        </span>

                        <span></span>
                      </div>
                    </td>

                    <td className="tr-bordered" colSpan={2} rowSpan={7}>
                      <div style={inlineStyles}>
                        <span>{languageService("BEFORE FROG WORKING BACK")}</span>
                        <span>{languageService("TOWARDS SWITCH STAND ")}</span>
                      </div>
                    </td>

                    <td className="tr-bordered" colSpan={2} rowSpan={1}>
                      <label style={{ marginLeft: "5px", fontWeight: "bold" }}>{languageService("Turnout 11")} </label>
                    </td>

                    <td className="tr-bordered" style={{ display: "-ms-inline-flexbox", flexDirection: "column" }} colSpan={5} rowSpan={1}>
                      <div style={{ marginLeft: "5px" }}>
                        <label style={{ fontWeight: "bold" }}>
                          {languageService("Gauge")}
                          {":"}
                        </label>
                        <span style={{ marginLeft: "5px" }}>
                          {data && data.fft33} {data && getFractionInches(data.fs33)}
                        </span>

                        <span></span>
                      </div>

                      <div style={{ marginLeft: "5px" }}>
                        <label style={{ fontWeight: "bold" }}>
                          {languageService("Crosslevel")} (+/-){":"}
                        </label>
                        <span style={{ marginLeft: "5px" }}>
                          {data && data.fft34} {data && getFractionInches(data.fs34)}
                        </span>

                        <span></span>
                      </div>
                    </td>
                  </tr>

                  <tr>
                    <td className="tr-bordered" colSpan={4} rowSpan={1}>
                      <label style={{ marginLeft: "5px", fontWeight: "bold" }}>{languageService(`4 1/2" Point - Mainline`)} </label>
                    </td>

                    <td className="tr-bordered" style={{ display: "-ms-inline-flexbox", flexDirection: "column" }} colSpan={5} rowSpan={1}>
                      <div style={{ marginLeft: "5px" }}>
                        <label style={{ fontWeight: "bold" }}>
                          {languageService("Point Elevation")}
                          {":"}
                        </label>
                        <span style={{ marginLeft: "5px" }}>
                          {data && data.fft3} {data && getFractionInches(data.fs3)}
                        </span>

                        <span></span>
                      </div>
                    </td>

                    <td className="tr-bordered" colSpan={2} rowSpan={1}>
                      <label style={{ marginLeft: "5px", fontWeight: "bold" }}>{languageService("Turnout 10")} </label>
                    </td>

                    <td className="tr-bordered" style={{ display: "-ms-inline-flexbox", flexDirection: "column" }} colSpan={5} rowSpan={1}>
                      <div style={{ marginLeft: "5px" }}>
                        <label style={{ fontWeight: "bold" }}>
                          {languageService("Gauge")}
                          {":"}
                        </label>
                        <span style={{ marginLeft: "5px" }}>
                          {data && data.fft35} {data && getFractionInches(data.fs35)}
                        </span>

                        <span></span>
                      </div>

                      <div style={{ marginLeft: "5px" }}>
                        <label style={{ fontWeight: "bold" }}>
                          {languageService("Crosslevel")} (+/-){":"}
                        </label>
                        <span style={{ marginLeft: "5px" }}>
                          {data && data.fft36} {data && getFractionInches(data.fs36)}
                        </span>

                        <span></span>
                      </div>
                    </td>
                  </tr>

                  <tr>
                    <td className="tr-bordered" colSpan={4} rowSpan={1}>
                      <label style={{ marginLeft: "5px", fontWeight: "bold" }}>{languageService("Heel-Mainline")} </label>
                    </td>

                    <td className="tr-bordered" style={{ display: "-ms-inline-flexbox", flexDirection: "column" }} colSpan={5} rowSpan={1}>
                      <div style={{ marginLeft: "5px" }}>
                        <label style={{ fontWeight: "bold" }}>
                          {languageService("Gauge")}
                          {":"}
                        </label>
                        <span style={{ marginLeft: "5px" }}>
                          {data && data.fft4} {data && getFractionInches(data.fs4)}
                        </span>

                        <span></span>
                      </div>

                      <div style={{ marginLeft: "5px" }}>
                        <label style={{ fontWeight: "bold" }}>
                          {languageService("Crosslevel")} (+/-){":"}
                        </label>
                        <span style={{ marginLeft: "5px" }}>
                          {data && data.fft5} {data && getFractionInches(data.fs5)}
                        </span>

                        <span></span>
                      </div>
                    </td>

                    <td className="tr-bordered" colSpan={2} rowSpan={1}>
                      <label style={{ marginLeft: "5px", fontWeight: "bold" }}>{languageService("Turnout 9")} </label>
                    </td>

                    <td className="tr-bordered" style={{ display: "-ms-inline-flexbox", flexDirection: "column" }} colSpan={5} rowSpan={1}>
                      <div style={{ marginLeft: "5px" }}>
                        <label style={{ fontWeight: "bold" }}>
                          {languageService("Gauge")}
                          {":"}
                        </label>
                        <span style={{ marginLeft: "5px" }}>
                          {data && data.fft37} {data && getFractionInches(data.fs37)}
                        </span>

                        <span></span>
                      </div>

                      <div style={{ marginLeft: "5px" }}>
                        <label style={{ fontWeight: "bold" }}>
                          {languageService("Crosslevel")} (+/-){":"}
                        </label>
                        <span style={{ marginLeft: "5px" }}>
                          {data && data.fft38} {data && getFractionInches(data.fs38)}
                        </span>

                        <span></span>
                      </div>
                    </td>
                  </tr>

                  <tr>
                    <td className="tr-bordered" colSpan={2} rowSpan={4}>
                      <div style={inlineStyles}>
                        <span>{languageService("BEFORE FROG")} </span>
                      </div>
                    </td>

                    <td className="tr-bordered" colSpan={2} rowSpan={1}>
                      <label style={{ marginLeft: "5px", fontWeight: "bold" }}>{languageService("Mainline 1")} </label>
                    </td>

                    <td className="tr-bordered" style={{ display: "-ms-inline-flexbox", flexDirection: "column" }} colSpan={5} rowSpan={1}>
                      <div style={{ marginLeft: "5px" }}>
                        <label style={{ fontWeight: "bold" }}>
                          {languageService("Gauge")}
                          {":"}
                        </label>
                        <span style={{ marginLeft: "5px" }}>
                          {data && data.fft6} {data && getFractionInches(data.fs6)}
                        </span>

                        <span></span>
                      </div>

                      <div style={{ marginLeft: "5px" }}>
                        <label style={{ fontWeight: "bold" }}>
                          {languageService("Crosslevel")} (+/-){":"}
                        </label>
                        <span style={{ marginLeft: "5px" }}>
                          {data && data.fft7} {data && getFractionInches(data.fs7)}
                        </span>

                        <span></span>
                      </div>
                    </td>

                    <td className="tr-bordered" colSpan={2} rowSpan={1}>
                      <label style={{ marginLeft: "5px", fontWeight: "bold" }}>{languageService("Turnout 8")} </label>
                    </td>

                    <td className="tr-bordered" style={{ display: "-ms-inline-flexbox", flexDirection: "column" }} colSpan={5} rowSpan={1}>
                      <div style={{ marginLeft: "5px" }}>
                        <label style={{ fontWeight: "bold" }}>
                          {languageService("Gauge")}
                          {":"}
                        </label>
                        <span style={{ marginLeft: "5px" }}>
                          {data && data.fft39} {data && getFractionInches(data.fs39)}
                        </span>

                        <span></span>
                      </div>

                      <div style={{ marginLeft: "5px" }}>
                        <label style={{ fontWeight: "bold" }}>
                          {languageService("Crosslevel")} (+/-){":"}
                        </label>
                        <span style={{ marginLeft: "5px" }}>
                          {data && data.fft40} {data && getFractionInches(data.fs40)}
                        </span>

                        <span></span>
                      </div>
                    </td>
                  </tr>

                  <tr>
                    <td className="tr-bordered" colSpan={2} rowSpan={1}>
                      <label style={{ marginLeft: "5px", fontWeight: "bold" }}>{languageService("Mainline 2")}</label>
                    </td>

                    <td className="tr-bordered" style={{ display: "-ms-inline-flexbox", flexDirection: "column" }} colSpan={5} rowSpan={1}>
                      <div style={{ marginLeft: "5px" }}>
                        <label style={{ fontWeight: "bold" }}>
                          {languageService("Gauge")}
                          {":"}
                        </label>
                        <span style={{ marginLeft: "5px" }}>
                          {data && data.fft8} {data && getFractionInches(data.fs8)}
                        </span>

                        <span></span>
                      </div>

                      <div style={{ marginLeft: "5px" }}>
                        <label style={{ fontWeight: "bold" }}>
                          {languageService("Crosslevel")} (+/-){":"}
                        </label>
                        <span style={{ marginLeft: "5px" }}>
                          {data && data.fft9} {data && getFractionInches(data.fs9)}
                        </span>

                        <span></span>
                      </div>
                    </td>

                    <td className="tr-bordered" colSpan={2} rowSpan={1}>
                      <label style={{ marginLeft: "5px", fontWeight: "bold" }}>{languageService("Turnout 7")}</label>
                    </td>

                    <td className="tr-bordered" style={{ display: "-ms-inline-flexbox", flexDirection: "column" }} colSpan={5} rowSpan={1}>
                      <div style={{ marginLeft: "5px" }}>
                        <label style={{ fontWeight: "bold" }}>
                          {languageService("Gauge")}
                          {":"}
                        </label>
                        <span style={{ marginLeft: "5px" }}>
                          {data && data.fft41} {data && getFractionInches(data.fs41)}
                        </span>

                        <span></span>
                      </div>

                      <div style={{ marginLeft: "5px" }}>
                        <label style={{ fontWeight: "bold" }}>
                          {languageService("Crosslevel")} (+/-){":"}
                        </label>
                        <span style={{ marginLeft: "5px" }}>
                          {data && data.fft42} {data && getFractionInches(data.fs42)}
                        </span>

                        <span></span>
                      </div>
                    </td>
                  </tr>

                  <tr>
                    <td className="tr-bordered" colSpan={2} rowSpan={1}>
                      <label style={{ marginLeft: "5px", fontWeight: "bold" }}>{languageService("Mainline 3")}</label>
                    </td>

                    <td className="tr-bordered" style={{ display: "-ms-inline-flexbox", flexDirection: "column" }} colSpan={5} rowSpan={1}>
                      <div style={{ marginLeft: "5px" }}>
                        <label style={{ fontWeight: "bold" }}>
                          {languageService("Gauge")}
                          {":"}
                        </label>
                        <span style={{ marginLeft: "5px" }}>
                          {data && data.fft10} {data && getFractionInches(data.fs10)}
                        </span>

                        <span></span>
                      </div>

                      <div style={{ marginLeft: "5px" }}>
                        <label style={{ fontWeight: "bold" }}>
                          {languageService("Crosslevel")} (+/-){":"}
                        </label>
                        <span style={{ marginLeft: "5px" }}>
                          {data && data.fft11} {data && getFractionInches(data.fs11)}
                        </span>

                        <span></span>
                      </div>
                    </td>

                    <td className="tr-bordered" colSpan={2} rowSpan={1}>
                      <label style={{ marginLeft: "5px", fontWeight: "bold" }}>{languageService("Turnout 6")}</label>
                    </td>

                    <td className="tr-bordered" style={{ display: "-ms-inline-flexbox", flexDirection: "column" }} colSpan={5} rowSpan={1}>
                      <div style={{ marginLeft: "5px" }}>
                        <label style={{ fontWeight: "bold" }}>
                          {languageService("Gauge")}
                          {":"}
                        </label>
                        <span style={{ marginLeft: "5px" }}>
                          {data && data.fft43} {data && getFractionInches(data.fs43)}
                        </span>

                        <span></span>
                      </div>

                      <div style={{ marginLeft: "5px" }}>
                        <label style={{ fontWeight: "bold" }}>
                          {languageService("Crosslevel")} (+/-){":"}
                        </label>
                        <span style={{ marginLeft: "5px" }}>
                          {data && data.fft44} {data && getFractionInches(data.fs44)}
                        </span>

                        <span></span>
                      </div>
                    </td>
                  </tr>

                  <tr>
                    <td className="tr-bordered" colSpan={2} rowSpan={1}>
                      <label style={{ marginLeft: "5px", fontWeight: "bold" }}>{languageService("Mainline 4")}</label>
                    </td>

                    <td className="tr-bordered" style={{ display: "-ms-inline-flexbox", flexDirection: "column" }} colSpan={5} rowSpan={1}>
                      <div style={{ marginLeft: "5px" }}>
                        <label style={{ fontWeight: "bold" }}>
                          {languageService("Gauge")}
                          {":"}
                        </label>
                        <span style={{ marginLeft: "5px" }}>
                          {data && data.fft12} {data && getFractionInches(data.fs12)}
                        </span>

                        <span></span>
                      </div>

                      <div style={{ marginLeft: "5px" }}>
                        <label style={{ fontWeight: "bold" }}>
                          {languageService("Crosslevel")} (+/-){":"}
                        </label>
                        <span style={{ marginLeft: "5px" }}>
                          {data && data.fft13} {data && getFractionInches(data.fs13)}
                        </span>

                        <span></span>
                      </div>
                    </td>

                    <td className="tr-bordered" colSpan={2} rowSpan={1}>
                      <label style={{ marginLeft: "5px", fontWeight: "bold" }}>{languageService("Turnout 5")}</label>
                    </td>

                    <td className="tr-bordered" style={{ display: "-ms-inline-flexbox", flexDirection: "column" }} colSpan={5} rowSpan={1}>
                      <div style={{ marginLeft: "5px" }}>
                        <label style={{ fontWeight: "bold" }}>
                          {languageService("Gauge")}
                          {":"}
                        </label>
                        <span style={{ marginLeft: "5px" }}>
                          {data && data.fft45} {data && getFractionInches(data.fs45)}
                        </span>

                        <span></span>
                      </div>

                      <div style={{ marginLeft: "5px" }}>
                        <label style={{ fontWeight: "bold" }}>
                          {languageService("Crosslevel")} (+/-){":"}
                        </label>
                        <span style={{ marginLeft: "5px" }}>
                          {data && data.fft46} {data && getFractionInches(data.fs46)}
                        </span>

                        <span></span>
                      </div>
                    </td>
                  </tr>

                  <tr>
                    <td className="tr-bordered" colSpan={4} rowSpan={1}>
                      <label style={{ marginLeft: "5px", fontWeight: "bold" }}>{languageService("Frog-Mainline")}</label>
                    </td>

                    <td className="tr-bordered" style={{ display: "-ms-inline-flexbox", flexDirection: "column" }} colSpan={5} rowSpan={1}>
                      <div style={{ marginLeft: "5px" }}>
                        <label style={{ fontWeight: "bold" }}>
                          {languageService("Gauge")}
                          {":"}
                        </label>
                        <span style={{ marginLeft: "5px" }}>
                          {data && data.fft14} {data && getFractionInches(data.fs14)}
                        </span>

                        <span></span>
                      </div>

                      <div style={{ marginLeft: "5px" }}>
                        <label style={{ fontWeight: "bold" }}>
                          {languageService("Crosslevel")} (+/-){":"}
                        </label>
                        <span style={{ marginLeft: "5px" }}>
                          {data && data.fft15} {data && getFractionInches(data.fs15)}
                        </span>

                        <span></span>
                      </div>

                      <div style={{ marginLeft: "5px" }}>
                        <label style={{ fontWeight: "bold" }}>
                          {languageService("Guard Check")}
                          {":"}
                        </label>
                        <span style={{ marginLeft: "5px" }}>
                          {data && data.fft16} {data && getFractionInches(data.fs16)}
                        </span>

                        <span></span>
                      </div>

                      <div style={{ marginLeft: "5px" }}>
                        <label style={{ fontWeight: "bold" }}>
                          {languageService("Guard Face")}
                          {":"}
                        </label>
                        <span style={{ marginLeft: "5px" }}>
                          {data && data.fft17} {data && getFractionInches(data.fs17)}
                        </span>

                        <span></span>
                      </div>

                      <div style={{ marginLeft: "5px" }}>
                        <label style={{ fontWeight: "bold" }}>
                          {languageService("Flangeway Depth")}
                          {":"}
                        </label>
                        <span style={{ marginLeft: "5px" }}>
                          {data && data.fft18} {data && getFractionInches(data.fs18)}
                        </span>

                        <span></span>
                      </div>
                    </td>

                    <td className="tr-bordered" colSpan={4} rowSpan={1}>
                      <label style={{ marginLeft: "5px", fontWeight: "bold" }}>{languageService("Frog-Turnout")}</label>
                    </td>

                    <td className="tr-bordered" style={{ display: "-ms-inline-flexbox", flexDirection: "column" }} colSpan={5} rowSpan={1}>
                      <div style={{ marginLeft: "5px" }}>
                        <label style={{ fontWeight: "bold" }}>
                          {languageService("Gauge")}
                          {":"}
                        </label>
                        <span style={{ marginLeft: "5px" }}>
                          {data && data.fft47} {data && getFractionInches(data.fs47)}
                        </span>

                        <span></span>
                      </div>

                      <div style={{ marginLeft: "5px" }}>
                        <label style={{ fontWeight: "bold" }}>
                          {languageService("Crosslevel")} (+/-){":"}
                        </label>
                        <span style={{ marginLeft: "5px" }}>
                          {data && data.fft48} {data && getFractionInches(data.fs48)}
                        </span>

                        <span></span>
                      </div>

                      <div style={{ marginLeft: "5px" }}>
                        <label style={{ fontWeight: "bold" }}>
                          {languageService("Guard Check")}
                          {":"}
                        </label>
                        <span style={{ marginLeft: "5px" }}>
                          {data && data.fft49} {data && getFractionInches(data.fs49)}
                        </span>

                        <span></span>
                      </div>

                      <div style={{ marginLeft: "5px" }}>
                        <label style={{ fontWeight: "bold" }}>
                          {languageService("Guard Face")}
                          {":"}
                        </label>
                        <span style={{ marginLeft: "5px" }}>
                          {data && data.fft50} {data && getFractionInches(data.fs50)}
                        </span>

                        <span></span>
                      </div>

                      <div style={{ marginLeft: "5px" }}>
                        <label style={{ fontWeight: "bold" }}>
                          {languageService("Flangeway Depth")}
                          {":"}
                        </label>
                        <span style={{ marginLeft: "5px" }}>
                          {data && data.fft51} {data && getFractionInches(data.fs51)}
                        </span>

                        <span></span>
                      </div>
                    </td>
                  </tr>

                  <tr>
                    <td className="tr-bordered" colSpan={2} rowSpan={7}>
                      <div style={inlineStyles}>
                        <span>{languageService("AFTER FROG")}</span>
                      </div>
                    </td>
                    <td className="tr-bordered" colSpan={2} rowSpan={1}>
                      <label style={{ marginLeft: "5px", fontWeight: "bold" }}>{languageService("Mainline 5")}</label>
                    </td>

                    <td className="tr-bordered" style={{ display: "-ms-inline-flexbox", flexDirection: "column" }} colSpan={5} rowSpan={1}>
                      <div style={{ marginLeft: "5px" }}>
                        <label style={{ fontWeight: "bold" }}>
                          {languageService("Gauge")}
                          {":"}
                        </label>
                        <span style={{ marginLeft: "5px" }}>
                          {data && data.fft19} {data && getFractionInches(data.fs19)}
                        </span>

                        <span></span>
                      </div>

                      <div style={{ marginLeft: "5px" }}>
                        <label style={{ fontWeight: "bold" }}>
                          {languageService("Crosslevel")} (+/-){":"}
                        </label>
                        <span style={{ marginLeft: "5px" }}>
                          {data && data.fft20} {data && getFractionInches(data.fs20)}
                        </span>

                        <span></span>
                      </div>
                    </td>

                    <td className="tr-bordered" colSpan={2} rowSpan={4}>
                      <div style={inlineStyles}>
                        <span>{languageService("AFTER FROG WORKING BACK")}</span>
                        <span>{languageService("TOWARDS SWITCH STAND")}</span>
                      </div>
                    </td>

                    <td className="tr-bordered" colSpan={2} rowSpan={1}>
                      <label style={{ marginLeft: "5px", fontWeight: "bold" }}>{languageService("Turnout 4")}</label>
                    </td>

                    <td className="tr-bordered" style={{ display: "-ms-inline-flexbox", flexDirection: "column" }} colSpan={5} rowSpan={1}>
                      <div style={{ marginLeft: "5px" }}>
                        <label style={{ fontWeight: "bold" }}>
                          {languageService("Gauge")}
                          {":"}
                        </label>
                        <span style={{ marginLeft: "5px" }}>
                          {data && data.fft52} {data && getFractionInches(data.fs52)}
                        </span>

                        <span></span>
                      </div>

                      <div style={{ marginLeft: "5px" }}>
                        <label style={{ fontWeight: "bold" }}>
                          {languageService("Crosslevel")} (+/-){":"}
                        </label>
                        <span style={{ marginLeft: "5px" }}>
                          {data && data.fft53} {data && getFractionInches(data.fs53)}
                        </span>

                        <span></span>
                      </div>
                    </td>
                  </tr>

                  <tr>
                    <td className="tr-bordered" colSpan={2} rowSpan={1}>
                      <label style={{ marginLeft: "5px", fontWeight: "bold" }}>{languageService("Mainline 6")}</label>
                    </td>

                    <td className="tr-bordered" style={{ display: "-ms-inline-flexbox", flexDirection: "column" }} colSpan={5} rowSpan={1}>
                      <div style={{ marginLeft: "5px" }}>
                        <label style={{ fontWeight: "bold" }}>
                          {languageService("Gauge")}
                          {":"}
                        </label>
                        <span style={{ marginLeft: "5px" }}>
                          {data && data.fft21} {data && getFractionInches(data.fs21)}
                        </span>

                        <span></span>
                      </div>

                      <div style={{ marginLeft: "5px" }}>
                        <label style={{ fontWeight: "bold" }}>
                          {languageService("Crosslevel")} (+/-){":"}
                        </label>
                        <span style={{ marginLeft: "5px" }}>
                          {data && data.fft22} {data && getFractionInches(data.fs22)}
                        </span>

                        <span></span>
                      </div>
                    </td>

                    <td className="tr-bordered" colSpan={2} rowSpan={1}>
                      <label style={{ marginLeft: "5px", fontWeight: "bold" }}>{languageService("Turnout 3")}</label>
                    </td>

                    <td className="tr-bordered" style={{ display: "-ms-inline-flexbox", flexDirection: "column" }} colSpan={5} rowSpan={1}>
                      <div style={{ marginLeft: "5px" }}>
                        <label style={{ fontWeight: "bold" }}>
                          {languageService("Gauge")}
                          {":"}
                        </label>
                        <span style={{ marginLeft: "5px" }}>
                          {data && data.fft54} {data && getFractionInches(data.fs54)}
                        </span>

                        <span></span>
                      </div>

                      <div style={{ marginLeft: "5px" }}>
                        <label style={{ fontWeight: "bold" }}>
                          {languageService("Crosslevel")} (+/-){":"}
                        </label>
                        <span style={{ marginLeft: "5px" }}>
                          {data && data.fft55} {data && getFractionInches(data.fs55)}
                        </span>

                        <span></span>
                      </div>
                    </td>
                  </tr>

                  <tr>
                    <td className="tr-bordered" colSpan={2} rowSpan={1}>
                      <label style={{ marginLeft: "5px", fontWeight: "bold" }}>{languageService("Mainline 7")}</label>
                    </td>

                    <td className="tr-bordered" style={{ display: "-ms-inline-flexbox", flexDirection: "column" }} colSpan={5} rowSpan={1}>
                      <div style={{ marginLeft: "5px" }}>
                        <label style={{ fontWeight: "bold" }}>
                          {languageService("Gauge")}
                          {":"}
                        </label>
                        <span style={{ marginLeft: "5px" }}>
                          {data && data.fft23} {data && getFractionInches(data.fs23)}
                        </span>

                        <span></span>
                      </div>

                      <div style={{ marginLeft: "5px" }}>
                        <label style={{ fontWeight: "bold" }}>
                          {languageService("Crosslevel")} (+/-){":"}
                        </label>
                        <span style={{ marginLeft: "5px" }}>
                          {data && data.fft24} {data && getFractionInches(data.fs24)}
                        </span>

                        <span></span>
                      </div>
                    </td>

                    <td className="tr-bordered" colSpan={2} rowSpan={1}>
                      <label style={{ marginLeft: "5px", fontWeight: "bold" }}>{languageService("Turnout 2")}</label>
                    </td>

                    <td className="tr-bordered" style={{ display: "-ms-inline-flexbox", flexDirection: "column" }} colSpan={5} rowSpan={1}>
                      <div style={{ marginLeft: "5px" }}>
                        <label style={{ fontWeight: "bold" }}>
                          {languageService("Gauge")}
                          {":"}
                        </label>
                        <span style={{ marginLeft: "5px" }}>
                          {data && data.fft56} {data && getFractionInches(data.fs56)}
                        </span>

                        <span></span>
                      </div>

                      <div style={{ marginLeft: "5px" }}>
                        <label style={{ fontWeight: "bold" }}>
                          {languageService("Crosslevel")} (+/-){":"}
                        </label>
                        <span style={{ marginLeft: "5px" }}>
                          {data && data.fft57} {data && getFractionInches(data.fs57)}
                        </span>

                        <span></span>
                      </div>
                    </td>
                  </tr>

                  <tr>
                    <td className="tr-bordered" colSpan={2} rowSpan={1}>
                      <label style={{ marginLeft: "5px", fontWeight: "bold" }}>{languageService("Mainline 8")}</label>
                    </td>

                    <td className="tr-bordered" style={{ display: "-ms-inline-flexbox", flexDirection: "column" }} colSpan={5} rowSpan={1}>
                      <div style={{ marginLeft: "5px" }}>
                        <label style={{ fontWeight: "bold" }}>
                          {languageService("Gauge")}
                          {":"}
                        </label>
                        <span style={{ marginLeft: "5px" }}>
                          {data && data.fft25} {data && getFractionInches(data.fs25)}
                        </span>

                        <span></span>
                      </div>

                      <div style={{ marginLeft: "5px" }}>
                        <label style={{ fontWeight: "bold" }}>
                          {languageService("Crosslevel")} (+/-){":"}
                        </label>
                        <span style={{ marginLeft: "5px" }}>
                          {data && data.fft26} {data && getFractionInches(data.fs26)}
                        </span>

                        <span></span>
                      </div>
                    </td>

                    <td className="tr-bordered" colSpan={2} rowSpan={1}>
                      <label style={{ marginLeft: "5px", fontWeight: "bold" }}>{languageService("Turnout 1")}</label>
                    </td>

                    <td className="tr-bordered" style={{ display: "-ms-inline-flexbox", flexDirection: "column" }} colSpan={5} rowSpan={1}>
                      <div style={{ marginLeft: "5px" }}>
                        <label style={{ fontWeight: "bold" }}>
                          {languageService("Gauge")}
                          {":"}
                        </label>
                        <span style={{ marginLeft: "5px" }}>
                          {data && data.fft58} {data && getFractionInches(data.fs58)}
                        </span>

                        <span></span>
                      </div>

                      <div style={{ marginLeft: "5px" }}>
                        <label style={{ fontWeight: "bold" }}>
                          {languageService("Crosslevel")} (+/-){":"}
                        </label>
                        <span style={{ marginLeft: "5px" }}>
                          {data && data.fft59} {data && getFractionInches(data.fs59)}
                        </span>

                        <span></span>
                      </div>
                    </td>
                  </tr>

                  <tr>
                    <td className="tr-bordered" colSpan={2} rowSpan={1}>
                      <label style={{ marginLeft: "5px", fontWeight: "bold" }}>{languageService("Mainline 9")}</label>
                    </td>

                    <td className="tr-bordered" style={{ display: "-ms-inline-flexbox", flexDirection: "column" }} colSpan={5} rowSpan={1}>
                      <div style={{ marginLeft: "5px" }}>
                        <label style={{ fontWeight: "bold" }}>
                          {languageService("Gauge")}
                          {":"}
                        </label>
                        <span style={{ marginLeft: "5px" }}>
                          {data && data.fft27} {data && getFractionInches(data.fs27)}
                        </span>

                        <span></span>
                      </div>

                      <div style={{ marginLeft: "5px" }}>
                        <label style={{ fontWeight: "bold" }}>
                          {languageService("Crosslevel")} (+/-){":"}
                        </label>
                        <span style={{ marginLeft: "5px" }}>
                          {data && data.fft28} {data && getFractionInches(data.fs28)}
                        </span>

                        <span></span>
                      </div>
                    </td>

                    <td className="tr-bordered" colSpan={4} rowSpan={1}>
                      <label style={{ marginLeft: "5px", fontWeight: "bold" }}>{languageService("Heel - Turnout")}</label>
                    </td>

                    <td className="tr-bordered" style={{ display: "-ms-inline-flexbox", flexDirection: "column" }} colSpan={5} rowSpan={1}>
                      <div style={{ marginLeft: "5px" }}>
                        <label style={{ fontWeight: "bold" }}>
                          {languageService("Gauge")}
                          {":"}
                        </label>
                        <span style={{ marginLeft: "5px" }}>
                          {data && data.fft60} {data && getFractionInches(data.fs60)}
                        </span>

                        <span></span>
                      </div>

                      <div style={{ marginLeft: "5px" }}>
                        <label style={{ fontWeight: "bold" }}>
                          {languageService("Crosslevel")} (+/-){":"}
                        </label>
                        <span style={{ marginLeft: "5px" }}>
                          {data && data.fft61} {data && getFractionInches(data.fs61)}
                        </span>

                        <span></span>
                      </div>
                    </td>
                  </tr>

                  <tr>
                    <td className="tr-bordered" colSpan={2} rowSpan={1}>
                      <label style={{ marginLeft: "5px", fontWeight: "bold" }}>{languageService("Mainline 10")}</label>
                    </td>

                    <td className="tr-bordered" style={{ display: "-ms-inline-flexbox", flexDirection: "column" }} colSpan={5} rowSpan={1}>
                      <div style={{ marginLeft: "5px" }}>
                        <label style={{ fontWeight: "bold" }}>
                          {languageService("Gauge")}
                          {":"}
                        </label>
                        <span style={{ marginLeft: "5px" }}>
                          {data && data.fft29} {data && getFractionInches(data.fs29)}
                        </span>

                        <span></span>
                      </div>

                      <div style={{ marginLeft: "5px" }}>
                        <label style={{ fontWeight: "bold" }}>
                          {languageService("Crosslevel")} (+/-){":"}
                        </label>
                        <span style={{ marginLeft: "5px" }}>
                          {data && data.fft30} {data && getFractionInches(data.fs30)}
                        </span>

                        <span></span>
                      </div>
                    </td>

                    <td className="tr-bordered" colSpan={4} rowSpan={1}>
                      <label style={{ marginLeft: "5px", fontWeight: "bold" }}>{languageService(`4 1/2" Point-Turnout`)}</label>
                    </td>

                    <td className="tr-bordered" style={{ display: "-ms-inline-flexbox", flexDirection: "column" }} colSpan={5} rowSpan={1}>
                      <div style={{ marginLeft: "5px" }}>
                        <label style={{ fontWeight: "bold" }}>
                          {languageService("Point Elevation")}
                          {":"}
                        </label>
                        <span style={{ marginLeft: "5px" }}>
                          {data && data.fft62} {data && getFractionInches(data.fs62)}
                        </span>

                        <span></span>
                      </div>
                    </td>
                  </tr>

                  <tr>
                    <td className="tr-bordered" colSpan={2} rowSpan={1}>
                      <label style={{ marginLeft: "5px", fontWeight: "bold" }}>{languageService("Mainline 11")} </label>
                    </td>

                    <td className="tr-bordered" style={{ display: "-ms-inline-flexbox", flexDirection: "column" }} colSpan={5} rowSpan={1}>
                      <div style={{ marginLeft: "5px" }}>
                        <label style={{ fontWeight: "bold" }}>
                          {languageService("Gauge")}
                          {":"}
                        </label>
                        <span style={{ marginLeft: "5px" }}>
                          {data && data.fft31} {data && getFractionInches(data.fs31)}
                        </span>

                        <span></span>
                      </div>

                      <div style={{ marginLeft: "5px" }}>
                        <label style={{ fontWeight: "bold" }}>
                          {languageService("Crosslevel")} (+/-){":"}
                        </label>
                        <span style={{ marginLeft: "5px" }}>
                          {data && data.fft32} {data && getFractionInches(data.fs32)}
                        </span>

                        <span></span>
                      </div>
                    </td>

                    <td className="tr-bordered" colSpan={9} rowSpan={1}></td>
                  </tr>
                  <br></br>
                  <tr>
                    <td className="tr-no-bordered" colSpan={18} rowSpan={1}>
                      <h4 style={{ fontWeight: "bold" }}>{languageService("COMMENTS")}</h4>
                    </td>
                  </tr>
                  <tr>
                    <td className="tr-bordered" style={{ height: "220px" }} colSpan={18} rowSpan={1}>
                      <span style={{ marginLeft: "5px" }}> {data && data.com}</span>
                    </td>
                  </tr>

                  <tr>
                    <td className="tr-no-bordered left no-padding" colSpan={18} style={{ paddingTop: "0" }} rowSpan={1}>
                      {languageService(
                        "All Gauge and Crosslevel measurements should be taken starting at the switch point and moving out.",
                      )}
                    </td>
                  </tr>
                </tbody>
              </table>
            </Col>
          </Row>
        </div>
      </React.Fragment>
    );
  }
}

export default DetailedTurnoutInspectionForm;

function addEmptyColsIfNotEnough(mapArray, minRows) {
  let emptyRows = null;
  let countToAdd = minRows - mapArray.length;

  if (countToAdd > 0) {
    emptyRows = [];
    for (let i = 0; i < countToAdd; i++) {
      let row = <tr>{getCols(20)}</tr>;
      emptyRows.push(row);
    }
  }

  return emptyRows;
}
function getCols(num) {
  let cols = [];
  let span = [2, 2, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 8, 4];
  for (let i = 0; i < num; i++) {
    cols.push(<td colSpan={span[i]}></td>);
  }
  return cols;
}

const getFractionInches = (value) => {
  let result = "";
  if (value) {
    if (value.includes("0")) {
      return result;
    }

    let numbers = value.replaceAll(`'`, "");
    numbers = numbers.split("/");

    result = (
      <Fragment>
        <span style={{ whiteSpace: "nowrap" }}>
          <sup>{numbers[0]}</sup>⁄<sub>{numbers[1]}</sub>
        </span>
      </Fragment>
    );
  }

  return result;
};



// WEBPACK FOOTER //
// ./src/components/Reports/Timps/Ontario/DetailedTurnoutInspectionFormNew.jsx